var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("select-dialog", {
    attrs: {
      title: _vm.$t("CargoMsg.Cargo_SelectSpecificBusinessRule"),
      "row-data": _vm.rowData,
      "column-defs": _vm.columnDefs,
      "filter-keys": ["ruleName"],
      value: _vm.specificBusinessRuleUuid,
      "event-name": _vm.eventName,
      "input-width": _vm.inputWidth,
      "display-name-field": "ruleName"
    },
    on: { change: _vm.changeTrigger }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }